import { EventEmitter, Injectable } from '@angular/core';
import { ObjectValue } from 'src/app/reports/models/object-value.model';
import { getPropertyTypeBySystemType } from 'src/app/reports/helpers/property-type.helper';
import { PropertyType } from 'src/app/reports/shared/rte-form/schema/property-type.enum';
import { OpenColumnOptions } from './open-column-options.model';
import { TotalizerTypeEnum } from 'src/app/reports/enums/column-type.enum';

@Injectable({
  providedIn: 'root'
})
export class ColumnOptionsService {

  onOpenColumnOptions: EventEmitter<OpenColumnOptions> = new EventEmitter<OpenColumnOptions>();

  constructor() { }

  openColumnOptions(option: OpenColumnOptions) {
    this.onOpenColumnOptions.emit(option);
  }

  getTotalizerTypeOptions(): ObjectValue[] {
    return [
      new ObjectValue('Soma (SUM)', TotalizerTypeEnum.Sum),
      new ObjectValue('Mínimo (MIN)', TotalizerTypeEnum.Min),
      new ObjectValue('Máximo (MAX)', TotalizerTypeEnum.Max),
      new ObjectValue('Média (AVG)', TotalizerTypeEnum.Average),
      new ObjectValue('Contador (COUNT)', TotalizerTypeEnum.Count)
    ];
  }

  getTotalizerTypeOptionsByColumnType(columnType: string) {
    const type = getPropertyTypeBySystemType(columnType),
      options = this.getTotalizerTypeOptions(),
      ignore = [];

    if (type !== PropertyType.Number) {
      ignore.push(TotalizerTypeEnum.Average);
      ignore.push(TotalizerTypeEnum.Min);
      ignore.push(TotalizerTypeEnum.Max);
      ignore.push(TotalizerTypeEnum.Sum);
      ignore.push(TotalizerTypeEnum.Count);
    }

    return options.filter(x => !ignore.includes(x.Value));
  }
}
